module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "input-group"
  }, [(_vm.label && _vm.label.length > 0) ? _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v(_vm._s(_vm.label))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "fg-line"
  }, [_vm._l((_vm.source), function(item, index) {
    return [_c('c-checkbox', {
      key: index,
      attrs: {
        "is-enabled": _vm.isEnabled,
        "dvalue": item[_vm.svalue],
        "label": item[_vm.stext]
      },
      model: {
        value: (_vm.myvalue),
        callback: function($$v) {
          _vm.myvalue = $$v
        },
        expression: "myvalue"
      }
    }), _vm._v(" \n            ")]
  })], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1d4f3ee4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/checkboxgroup.vue
// module id = 546
// module chunks = 23